var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "0l8hofoaxa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119DF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0764E3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.504 36.123V15.82a5.668 5.668 0 0 0-2.835-4.909L26.087.759a5.672 5.672 0 0 0-5.669 0L2.835 10.911A5.668 5.668 0 0 0 0 15.82v20.303a5.671 5.671 0 0 0 2.835 4.91l17.583 10.151a5.667 5.667 0 0 0 5.669 0l17.582-10.151a5.671 5.671 0 0 0 2.835-4.91",
    fill: "url(#0l8hofoaxa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137 27.003h6.865a1 1 0 0 1 .992 1.124l-.577 4.616 6.45-7.74h-6.865a1 1 0 0 1-.992-1.124l.577-4.616-6.45 7.74zm5.732 2h-7.867a1 1 0 0 1-.768-1.64l10-12c.639-.767 1.884-.227 1.76.764l-.86 6.876h7.868a1 1 0 0 1 .768 1.64l-10 12c-.64.767-1.884.227-1.76-.764l.859-6.876z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.07b6a6b23073b69ac56583e0d0a35200.svg";
export { ForwardRef as ReactComponent };